export * as DatadogClient from './dataDogClient';
export type { RumInitConfiguration, LogsInitConfiguration } from './dataDogClient';